{
  "notFound": {
    "title": "Página no encontrada",
    "description": "Lo siento, la página que buscas no existe."
  },
  "fatalError": {
    "title": "La configuración de la aplicación falló.",
    "description": "Intenta recargar la página."
  },
  "buttons": {
    "back": "Volver",
    "cancel": "Cancelar",
    "validate": "Validar"
  },
  "profile": {
    "title": "Perfil",
    "subtitle": "Información del perfil",
    "logout": "Cerrar sesión",
    "language": "Idioma",
    "settings": "Configuración",
    "administration": "Administración",
    "userManagement": "Gestión de usuarios",
    "selectLanguage": "Seleccionar idioma",
    "logoutDialog": {
      "title": "¿Cerrar sesión?",
      "description": "Todos tus informes se guardarán y estarán disponibles cuando inicies sesión nuevamente"
    },
    "personalInformation": {
      "title": "Información personal",
      "fields": {
        "lastName": "Apellido",
        "firstName": "Nombre",
        "email": "Correo electrónico",
        "country": "País",
        "organization": "Organización"
      }
    }
  },
  "board": {
    "title": "Salud global de la fauna silvestre en el mundo"
  },
  "navigation": {
    "board": "Panel",
    "myReports": "Mis informes",
    "addReport": "Agregar informe",
    "resources": "Recursos",
    "alerts": "Alertas",
    "userManagement": "Gestión de usuarios",
    "profile": "Perfil",
    "appTitle": "WildEpi",
    "map": "Carta",
    "list": "Lista"
  },
  "alerts": {
    "markAllAsRead": "Marcar todo como leído",
    "updateOnReport": "Actualización del informe",
    "reportUpdated": "{{reportCode}} ha sido actualizado",
    "savedOnReport": "Informe guardado",
    "reportSaved": "{{reportCode}} ha sido guardado",
    "rraRequestedOnReport": "Solicitud de ERR en el informe",
    "reportRraRequested": "Se solicitó una ERR para {{reportCode}}",
    "rraCompletedOnReport": "ERR completada en el informe",
    "reportRraCompleted": "La ERR se completó para {{reportCode}}",
    "draftOnReport": "Borrador del informe",
    "reportDraft": "{{reportCode}} ha sido guardado como borrador",
    "emptyTitle": "No hay alertas por ahora"
  },
  "resources": {
    "learningMaterial": "Material de aprendizaje",
    "helpAndSupport": "Ayuda y soporte",
    "trainingVideos": "Videos de capacitación",
    "about": "Información general",
    "faqs": "Preguntas frecuentes",
    "reportBug": "Reportar error o problema"
  },
  "app": {
    "name": "WildEpi"
  },
  "login": {
    "sso": "Inicio de sesión SSO",
    "welcome": "Bienvenido a WildEpi"
  },
  "auth": {
    "userLoadError": {
      "title": "No pudimos cargar tu perfil",
      "description": "Intenta de nuevo para continuar usando la aplicación."
    },
    "retry": "Reintentar",
    "loadingProfile": "Cargando tu perfil..."
  },
  "offlineMode": {
    "banner": "Estás sin conexión. Solo está disponible la creación de informes."
  },
  "noData": "No se han encontrado datos.",
  "reportCreation": {
    "title": "Crear un informe",
    "editTitle": "Editar un informe",
    "backToReport": "Volver al informe",
    "steps": {
      "generalInformation": "Información general",
      "surveillanceAndEtiology": "Vigilancia y etiología",
      "diagnosticProcedure": "Procedimiento diagnóstico",
      "supportingDocuments": "Documentos de respaldo"
    },
    "buttons": {
      "saveAsDraft": "Guardar como borrador",
      "deleteDraft": "Eliminar borrador",
      "next": "Siguiente",
      "save": "Guardar",
      "publish": "Publicar"
    },
    "success": {
      "title": "Tu informe ha sido publicado",
      "subtitle": "Edítalo en cualquier momento y encuéntralo de nuevo en Mis informes.",
      "validateButton": "Validar",
      "draftTitle": "Tu informe se ha guardado como borrador",
      "draftSubtitle": "Este informe se ha guardado como borrador. Puedes encontrarlo en tu lista de informes.",
      "queuedTitle": "Tu informe está pendiente de sincronización",
      "queuedSubtitle": "Lo enviaremos automáticamente en cuanto la conexión esté disponible.",
      "csvImportPublishedTitle": "Tus informes se están sincronizando",
      "csvImportPublishedSubtitle": "Aparecerán en Mis informes cuando la sincronización finalice.",
      "csvImportDraftTitle": "Tus informes se están sincronizando",
      "csvImportDraftSubtitle": "Las filas válidas se publicarán. Las filas inválidas se guardarán como borradores para completarlas más tarde.",
      "csvImportResultTitle": "Importación CSV completada",
      "csvImportResultSubtitle": "Resumen de los informes importados.",
      "csvImportResultPublished": "{{count}} informe(s) publicado(s)",
      "csvImportResultDraft": "{{count}} informe(s) en borrador",
      "csvImportResultError": "{{count}} informe(s) con error"
    },
    "toasts": {
      "submitError": "Ocurrió un error al guardar el informe. Inténtelo de nuevo.",
      "uploadSupportingDocumentsError": "Ocurrió un error al subir los documentos de respaldo. Inténtelo de nuevo.",
      "similarReportsMissingLocation": "Introduce coordenadas válidas antes de publicar.",
      "similarReportsError": "No pudimos comprobar informes similares. Inténtalo de nuevo.",
      "offlineQueueAdded": "Informe agregado a la cola de envío sin conexión.",
      "offlineQueueProcessed": "Se sincronizaron los informes pendientes."
    },
    "similarReports": {
      "title": "Validar informe",
      "heading": "Encontramos informes similares",
      "subheading": "Revisa los siguientes informes antes de publicar."
    },
    "versionNote": {
      "title": "Agregar nota de versión",
      "heading": "Agregar nota de versión",
      "fieldLabel": "Nota de versión",
      "placeholder": "Describe el motivo de la edición"
    },
    "deleteDraftDialog": {
      "title": "¿Eliminar borrador?",
      "description": "Este borrador se eliminará y toda la información ingresada se perderá.",
      "confirm": "Eliminar borrador"
    },
    "creationModeModal": {
      "title": "Agregar informe",
      "description": "Elija un tipo de creación de informe",
      "inAppForm": "Formulario en la app",
      "csvImport": "Importar CSV"
    },
    "csvImportModal": {
      "title": "Importación CSV",
      "dropzoneTitle": "Haga clic para agregar un archivo",
      "dropzoneSubtitle": "Formato CSV (máx. 15 MB)",
      "back": "Volver",
      "import": "Importar",
      "saveAsDraft": "Guardar como borrador",
      "publish": "Publicar",
      "downloadTemplate": "Descargar plantilla"
    },
    "csvImportValidation": {
      "file": "Archivo",
      "errorRowLabel": "Fila {{rowNumber}} - {{columnHeader}}",
      "summary": {
        "valid": "Validación correcta. {{totalRows}} fila(s) listas para importar.",
        "invalid": "Validación fallida. {{validRows}} válida(s) / {{invalidRows}} inválida(s) de {{totalRows}}."
      },
      "errors": {
        "noFileSelected": "Selecciona un archivo CSV antes de importar.",
        "unableToReadFile": "No se puede leer el archivo seleccionado.",
        "emptyFile": "El archivo CSV está vacío.",
        "noDataRows": "No se encontraron filas de datos. Agrega al menos una fila de informe.",
        "missingColumn": "Falta una columna en el encabezado CSV.",
        "unexpectedColumn": "Columna inesperada en el encabezado CSV.",
        "requiredField": "Este campo es obligatorio.",
        "invalidOption": "El valor no coincide con los valores permitidos.",
        "invalidDynamicOption": "El valor no coincide con los valores permitidos.",
        "invalidDate": "Fecha inválida. Formato esperado: AAAA-MM-DD o DD/MM/AAAA.",
        "invalidNumber": "Número inválido.",
        "numberBelowZero": "El valor debe ser mayor o igual a 0.",
        "populationMustBeAboveZero": "El tamaño de la población debe ser mayor que 0.",
        "invalidLatitude": "La latitud debe estar entre -90 y 90.",
        "invalidLongitude": "La longitud debe estar entre -180 y 180.",
        "totalCountTooLow": "El total de pruebas debe ser al menos igual a pruebas positivas + negativas.",
        "textTooLong": "El texto supera la longitud máxima ({{count}} caracteres)."
      }
    },
    "csvTemplate": {
      "diagnosticPrefix": "Diagnóstico",
      "hints": {
        "dynamicOptionExactMatch": "Selecciona un valor de la lista de la app (el texto debe coincidir exactamente).",
        "species": "Introduce el nombre científico de la especie (nombre exacto).",
        "yesNo": "Sí | No",
        "date": "Formato de fecha: AAAA-MM-DD",
        "nonNegativeNumber": "Número >= 0",
        "populationSize": "Número > 0 y al menos igual a muertos + enfermos.",
        "totalCount": "Número >= pruebas positivas + pruebas negativas.",
        "maxCharacters_one": "Texto libre (máx. {{count}} carácter).",
        "maxCharacters_other": "Texto libre (máx. {{count}} caracteres).",
        "freeText": "Texto libre",
        "latitude": "Latitud decimal (WGS84).",
        "longitude": "Longitud decimal (WGS84)."
      }
    },
    "errors": {
      "requiredField": "Este campo es obligatorio",
      "countryForbidden": "No se pueden crear informes en este país.",
      "noCountryCoordinates": "No hay ningún país asociado a estas coordenadas.",
      "futureDetectionDate": "La fecha de detección no puede ser posterior a la fecha actual.",
      "populationMustBeGreaterThanZero": "El tamaño de la población debe ser mayor que 0.",
      "populationTooSmall": "El tamaño de la población debe ser al menos la suma de muertos y enfermos.",
      "testsMustBeNonNegative": "El número de pruebas debe ser mayor o igual a 0.",
      "testsGreaterThanPopulation": "El número de pruebas no puede superar el tamaño de la población.",
      "totalTestsTooLow": "El número total de pruebas debe ser al menos la suma de los positivos y negativos.",
      "totalTestsMustBeGreaterThanZero": "El número total de pruebas debe ser mayor que 0.",
      "wahisAgentInWahis": "Este agente etiológico se gestiona en la aplicación WAHIS. Por favor, repórtalo allí."
    },
    "common": {
      "characterLimit": "{{currentLength}}/{{maxLength}} caracteres máximos",
      "noResults": "No se encontraron resultados",
      "useCustomValue": "Usar \"{{value}}\" como valor personalizado"
    },
    "step1": {
      "sections": {
        "animalDescription": "Descripción del animal",
        "location": "Ubicación - WGS84",
        "dateOfDetection": "Fecha de detección"
      },
      "fields": {
        "animalType": "Tipo de animal",
        "species": "Especie",
        "wildtype": "Tipo silvestre",
        "location": "Ubicación",
        "dateOfDetection": "Fecha de detección",
        "inaccurateLocation": "Ubicación aproximada"
      },
      "placeholders": {
        "selectSpecies": "Selecciona especie o grupo",
        "speciesFreeText": "Introduce una especie",
        "latitude": "Latitud",
        "longitude": "Longitud",
        "dateFormat": "DD/MM/YYYY"
      },
      "options": {
        "animalType": {
          "vertebrate": "Vertebrado",
          "invertebrate": "Invertebrado"
        },
        "wildtype": {
          "freeRoaming": "Libre",
          "captive": "Cautivo",
          "feral": "Asilvestrado"
        },
        "species": {
          "canisLupus": "Canis lupus",
          "bosTaurus": "Bos taurus",
          "susScrofa": "Sus scrofa",
          "anasPlatyrhynchos": "Anas platyrhynchos",
          "apisMellifera": "Apis mellifera"
        }
      }
    },
    "step2": {
      "sections": {
        "surveillance": "Vigilancia",
        "etiology": "Etiología"
      },
      "fields": {
        "surveillanceType": "Tipo de vigilancia",
        "description": "Descripción",
        "numberOfDeaths": "Número de individuos muertos",
        "numberOfSick": "Número de individuos enfermos",
        "populationSize": "Tamaño de la población (si se conoce)",
        "humanAffected": "Humano afectado",
        "domesticAnimalAffected": "Animal doméstico afectado",
        "knowTheCause": "¿Conoce la causa?",
        "etiologyType": "Tipo de etiología",
        "etiologyAgent": "Agente etiológico",
        "diagnosticProcedure": "Procedimiento diagnóstico"
      },
      "placeholders": {
        "describeSurveillance": "Describir vigilancia",
        "selectEtiologyType": "Seleccionar tipo de etiología",
        "selectEtiologyAgent": "Seleccionar agente etiológico"
      },
      "options": {
        "surveillanceType": {
          "active": "Activa",
          "passive": "Pasiva",
          "other": "Otra",
          "unknown": "Desconocida"
        },
        "yesNoUnknown": {
          "yes": "Sí",
          "no": "No",
          "iDontKnow": "No lo sé"
        },
        "yesNo": {
          "yes": "Sí",
          "no": "No"
        },
        "diagnosticProcedure": {
          "yes": "Sí",
          "no": "No"
        }
      },
      "helpers": {
        "etiologyAgentHint": "Si su agente no está en la lista, escríbalo aquí para añadirlo."
      },
      "warnings": {
        "massMortality": "Mensaje de advertencia: se reporta un evento de mortalidad o morbilidad masiva. ¿El número de animales afectados es correcto?"
      }
    },
    "step3": {
      "diagnosticProcedureTitle": "Procedimiento diagnóstico",
      "sections": {
        "sampling": "Muestreo",
        "tests": "Pruebas",
        "results": "Resultados"
      },
      "fields": {
        "sampleType": "Tipo de muestra",
        "category": "Categoría",
        "subcategory": "Subcategoría",
        "family": "Familia",
        "positiveCount": "Número de pruebas positivas",
        "negativeCount": "Número de pruebas negativas",
        "totalCount": "Número total de pruebas",
        "extraTestInfo": "Información adicional de la prueba"
      },
      "placeholders": {
        "sampleType": "Buscar tipo de muestra",
        "subcategory": "Seleccionar subcategoría",
        "family": "Seleccionar familia",
        "extraTestInfo": "Describe la información de la prueba"
      },
      "options": {
        "category": {
          "direct": "Directa",
          "indirect": "Indirecta",
          "observation": "Observación",
          "others": "Otras"
        },
        "subcategory": {
          "pcr": "PCR",
          "microscopy": "Microscopía",
          "serology": "Serología",
          "fieldObservation": "Observación de campo"
        },
        "family": {
          "viralIsolation": "Aislamiento viral",
          "genomicSequencing": "Secuenciación genómica",
          "elisa": "ELISA",
          "rapidTest": "Prueba rápida"
        }
      },
      "actions": {
        "addProcedure": "Agregar prueba",
        "addButtonSectionTitle": "¿Se realizaron pruebas adicionales?",
        "deleteProcedure": "Eliminar prueba"
      }
    },
    "step4": {
      "sections": {
        "attachments": "Archivos adjuntos"
      },
      "fields": {
        "attachDocuments": "Adjuntar documentos"
      },
      "helpers": {
        "tapToAddFile": "Toca para agregar un archivo",
        "fileFormats": "Formato PDF, DOCX, CSV, PNG, TXT o JPEG (máx. 15 MB)"
      },
      "errors": {
        "unsupportedFormat": "Algunos archivos no se agregaron porque el formato no está soportado.",
        "sizeExceeded": "Algunos archivos superan los 15 MB y fueron omitidos."
      }
    }
  },
  "reportDetail": {
    "title": "Detalles del informe",
    "header": {
      "author": "Autor",
      "creationDate": "Fecha de creación",
      "country": "País",
      "version": "Versión"
    },
    "sections": {
      "generalInformation": "Información general",
      "surveillanceAndEtiology": "Vigilancia y etiología",
      "diagnosticProcedure": "Procedimiento diagnóstico",
      "supportingDocuments": "Documentos de apoyo",
      "rapidRiskAssessment": "Evaluación rápida de riesgos (ERR)"
    },
    "fields": {
      "speciesAndOrder": "Especie y orden",
      "locationCoordinates": "Ubicación (latitud / longitud)",
      "locationAccuracyFlag": "Indicador de precisión de ubicación"
    },
    "missingIndicator": "Por completar",
    "diagnosticProcedureLabel": "Procedimiento diagnóstico {{index}}",
    "supportingDocuments": {
      "empty": "No hay documentos de apoyo.",
      "fileType": "Tipo",
      "fileSize": "Tamaño",
      "uploadDate": "Fecha de carga"
    },
    "toasts": {
      "openSupportingDocumentError": "No se pudo abrir el documento de apoyo. Inténtalo de nuevo.",
      "loadVersionsError": "No se pudieron cargar las versiones del informe. Inténtalo de nuevo.",
      "shareError": "No se pudo compartir el enlace del informe. Inténtalo de nuevo.",
      "copyShareUrlSuccess": "Enlace del informe copiado.",
      "copyShareUrlError": "No se pudo copiar el enlace del informe. Inténtalo de nuevo.",
      "requestRraError": "No se pudo solicitar una ERR . Inténtalo de nuevo.",
      "uploadRraError": "No se pudo subir el documento ERR . Inténtalo de nuevo."
    },
    "versions": {
      "title": "Versiones del informe",
      "versionLabel": "v. {{version}}"
    },
    "actions": {
      "edit": "Editar",
      "delete": "Eliminar",
      "requestRra": "Solicitar ERR ",
      "uploadRra": "Subir ERR ",
      "download": "Descargar",
      "open": "Abrir",
      "share": "Compartir",
      "copyShareUrl": "Copiar enlace del informe"
    },
    "share": {
      "title": "Compartir informe"
    },
    "deleteDialog": {
      "title": "¿Eliminar el informe?",
      "description": "Este informe se eliminará de su lista."
    },
    "rra": {
      "pendingState": "ERR pendiente",
      "pendingDescription": "El archivo estará visible aquí cuando se publique",
      "pdfLabel": "Documento ERR",
      "versionNote": "Documento ERR cargado"
    },
    "rraRequestSuccess": {
      "title": "Tu solicitud de evaluación rápida de riesgos ha sido enviada",
      "subtitle": "Una vez actualizado el estado, podrás ver el PDF en los detalles del informe.",
      "validateButton": "Ir al informe"
    },
    "values": {
      "yes": "Sí",
      "no": "No",
      "dontKnow": "No se sabe"
    }
  },
  "speciesSearch": {
    "title": "Especies",
    "searchPlaceholder": "Buscar especie o grupo taxonómico",
    "actions": {
      "taxonomyTree": "Árbol taxonómico",
      "identifyWithAi": "Identificar con IA"
    },
    "results": {
      "title": "Resultados de búsqueda"
    },
    "empty": {
      "noResults": "Sin resultados",
      "promptTitle": "Buscar una especie",
      "promptDescription": "Empiece a escribir para ver especies o grupos taxonómicos."
    },
    "ai": {
      "title": "Identificar con IA",
      "imagePreviewTitle": "Vista previa de la imagen",
      "previewDescription": "Usaremos este archivo para identificar la especie.",
      "processingTitle": "Analizando la especie...",
      "processingDescription": "Espera unos segundos mientras analizamos tu archivo.",
      "noResultsTitle": "No se encontraron coincidencias",
      "noResultsDescription": "No pudimos identificar la especie con este archivo.",
      "matchesTitle": "Encontramos {{count}} especies coincidentes",
      "matchesSubtitle": "Selecciona una especie para continuar",
      "bestMatch": "Mejor coincidencia",
      "otherMatches": "Otras coincidencias",
      "wrongGuess": "¿Mala sugerencia?",
      "trySearch": "Hacer una búsqueda",
      "emptyTitle": "Aún no hay resultados",
      "emptyDescription": "Toma o sube una imagen para identificar la especie."
    },
    "modals": {
      "addFileTitle": "Agregar archivo",
      "photoLibrary": "Biblioteca de fotos",
      "takePhoto": "Tomar foto",
      "chooseFile": "Elegir archivo"
    },
    "taxonomy": {
      "title": "Árbol taxonómico",
      "select": "Seleccionar {{level}}",
      "helperPrefix": "¿No sabes?",
      "helperSearch": "Prueba una búsqueda",
      "helperConnector": "o",
      "stopIdentification": "detener la identificación",
      "loading": "Cargando taxonomía...",
      "noResults": "No hay resultados de taxonomía.",
      "noResultsForSelection": "No hay resultados para \"{{label}}\".",
      "emptyTitle": "Sin datos de taxonomía",
      "emptyDescription": "El árbol taxonómico aparecerá aquí.",
      "unassigned": "No asignado"
    }
  },
  "reports": {
    "count": "{{count}} informes",
    "emptyStateDescription": "Una vez que envíes un informe, aparecerá aquí.",
    "emptyStateTitle": "Aún no hay informes",
    "individuals": "individuos",
    "action": {
      "viewMore": "Ver más"
    },
    "loadingMore": "Cargando más informes...",
    "exportCsv": "Exportar",
    "csvExport": {
      "headers": {
        "reportCode": "Código del informe",
        "versionNumber": "Número de versión",
        "userCountry": "País del usuario",
        "userOrganization": "Organización del usuario",
        "assets": "Adjuntos",
        "diagnosticSampleType": "Diagnóstico {{index}} - Tipo de muestra",
        "diagnosticSubcategory": "Diagnóstico {{index}} - Subcategoría",
        "diagnosticCategoryOfTest": "Diagnóstico {{index}} - Categoría de prueba",
        "diagnosticFamily": "Diagnóstico {{index}} - Familia",
        "diagnosticExtraTestInformation": "Diagnóstico {{index}} - Información adicional de la prueba",
        "diagnosticNumberOfNegativeTests": "Diagnóstico {{index}} - Número de pruebas negativas",
        "diagnosticNumberOfPositiveTests": "Diagnóstico {{index}} - Número de pruebas positivas",
        "diagnosticNumberOfTests": "Diagnóstico {{index}} - Número de pruebas"
      }
    },
    "pageSize": "Elementos por página",
    "sort": {
      "none": "Sin orden",
      "placeholder": "Ordenar por",
      "order": "Cambiar el orden"
    },
    "columns": {
      "species": "Especie",
      "disease": "Enfermedad",
      "individualsAffected": "Individuos afectados",
      "dateOfDetection": "Fecha de detección",
      "location": "Ubicación",
      "status": "Estado"
    }
  },
  "filters": {
    "title": "Filtros",
    "apply": "Aplicar",
    "clear": "Limpiar",
    "close": "Cerrar filtros",
    "open": "Filtrar",
    "sections": {
      "generalInformation": "Información general",
      "animal": "Animal",
      "surveillanceAndEtiology": "Vigilancia y etiología",
      "diagnosticProcedure": "Procedimiento diagnóstico"
    },
    "fields": {
      "reportName": "Nombre del informe",
      "status": "Estado",
      "country": "País",
      "region": "Región",
      "dateOfDetection": "Fecha de detección",
      "animalType": "Tipo",
      "order": "Orden",
      "species": "Especie",
      "wildType": "Tipo silvestre",
      "surveillanceType": "Tipo de vigilancia",
      "knownCause": "Conocimiento de la causa",
      "etiologyType": "Tipo de etiología",
      "etiologicalAgent": "Agente etiológico",
      "diagnosticProcedure": "Procedimiento diagnóstico",
      "sampleType": "Tipo de muestra",
      "categoryOfTest": "Tipo de prueba"
    },
    "placeholders": {
      "reportName": "Todos los nombres de informes",
      "status": "Todos los estados",
      "country": "Todos los países",
      "region": "Todas las regiones",
      "dateRange": "Todas las fechas",
      "order": "Todos los órdenes",
      "species": "Todas las especies",
      "wildType": "Todos los tipos silvestres",
      "surveillanceType": "Todos los tipos",
      "etiologyType": "Todos los tipos",
      "etiologicalAgent": "Todos los agentes",
      "sampleType": "Todos los tipos",
      "categoryOfTest": "Todos los tipos"
    },
    "options": {
      "all": "Todos",
      "status": {
        "published": "Publicado",
        "pendingRra": "ERR pendiente",
        "publishedRra": "ERR publicada",
        "draft": "Borrador",
        "incorrect": "Incorrecto"
      }
    },
    "dateRange": {
      "start": "Inicio",
      "end": "Fin",
      "today": "Hoy"
    }
  },
  "pinPosition": {
    "selectLocation": "Seleccionar ubicación",
    "longitude": "Longitud",
    "latitude": "Latitud",
    "modalTitle": "Ubicación del animal/muestra",
    "coordinatesTitle": "WGS84 ubicación"
  },
  "userManagement": {
    "title": "Gestión de usuarios",
    "actions": {
      "add": "Agregar usuario",
      "edit": "Editar",
      "delete": "Eliminar",
      "deactivate": "Desactivar usuario",
      "save": "Guardar"
    },
    "columns": {
      "name": "Nombre",
      "firstName": "Nombre",
      "lastName": "Apellido",
      "email": "Correo electrónico",
      "country": "País",
      "organization": "Organización",
      "role": "Rol",
      "status": "Estado",
      "creationDate": "Fecha de creación",
      "actions": "Acciones"
    },
    "filters": {
      "allCountries": "Todos los países",
      "allRoles": "Todos los roles",
      "allStatuses": "Todos los estados",
      "country": "País",
      "role": "Rol",
      "status": "Estado"
    },
    "search": {
      "label": "Buscar",
      "placeholder": "Buscar por nombre o correo electrónico"
    },
    "roles": {
      "basic": "Básico",
      "validated": "Validado",
      "focalPoint": "Punto focal",
      "delegate": "Delegado",
      "referenceCenter": "Centro de referencia",
      "adminViewOnly": "Admin (solo lectura)",
      "admin": "Admin"
    },
    "status": {
      "active": "Activo",
      "inactive": "Inactivo"
    },
    "form": {
      "fullName": "Nombre completo",
      "firstName": "Nombre",
      "lastName": "Apellido",
      "organization": "Organización",
      "email": "Correo electrónico",
      "country": "País",
      "role": "Rol",
      "fullNamePlaceholder": "Ingresar nombre completo",
      "firstNamePlaceholder": "Ingresar nombre",
      "lastNamePlaceholder": "Ingresar apellido",
      "organizationPlaceholder": "Ingresar organización",
      "emailPlaceholder": "Ingresar correo electrónico",
      "countryPlaceholder": "Seleccionar país",
      "rolePlaceholder": "Seleccionar rol"
    },
    "errors": {
      "required": "Este campo es obligatorio",
      "email": "Ingresa un correo electrónico válido"
    },
    "modal": {
      "createTitle": "Agregar usuario",
      "editTitle": "Editar usuario",
      "createDescription": "Completa la información a continuación.",
      "editDescription": "Actualiza la información a continuación.",
      "discardTitle": "¿Descartar cambios?",
      "discardDescription": "Se perderán tus cambios.",
      "discard": "Descartar"
    },
    "deleteDialog": {
      "title": "¿Desactivar usuario?",
      "description": "Esto desactivará al usuario y eliminará su acceso."
    },
    "empty": {
      "list": "No se encontraron usuarios.",
      "country": "Sin país",
      "date": "Sin fecha"
    },
    "loading": "Cargando usuarios...",
    "noAccess": {
      "title": "Acceso restringido",
      "description": "No tienes permiso para ver la gestión de usuarios."
    }
  }
}
